module.exports = __webpack_public_path__ + "img/质量监测.d2c2a4fb.svg";